export default __webpack_public_path__ + "static/media/LPplaceholder.5d3cf0dd.png";